import type { CancelSubscriptionApiQuery } from "@/Modules/Models/Api/Subscription";

import { cancelSubscription } from "@/Services/TherapyApi/Subscriptions";

import useAppStore from "@/Modules/App/Store";
import useSubscriptionStore from "@/Modules/Subscription/Store";

import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { log } from "@/Utils/Debug";

async function cancelSubscriptionAH(cancelSubscriptionApiQuery: CancelSubscriptionApiQuery): Promise<void> {
  const appStore = useAppStore();
  const subscriptionStore = useSubscriptionStore();

  subscriptionStore.isLoading = true;

  try {
    await cancelSubscription(cancelSubscriptionApiQuery);

    appStore.showSnackbar({
      type: NotificationType.SUCCESS,
      message: "settings.subscription.patient.subscription.cancel.success",
    });
  } catch (error) {
    subscriptionStore.notification = {
      type: NotificationType.ERROR,
      message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
      code: "generic error",
    };

    log(error);
  } finally {
    subscriptionStore.isLoading = false;
  }
}

export default cancelSubscriptionAH;
